import { getParsedQuery } from '@/core/utils/parsedQuery';

declare const isProd: boolean;
declare const isFederation: boolean;

export const PROJECT_ID = window.env.PROJECT_ID;

export let WHITELABEL_NAME = process.env.WHITELABEL;
export let WL_ORG_ID: string;
export let WL_CLIENT_ID: string;

const WHITELABEL = process.env.WHITELABEL;
export const isFederationMode = isFederation;

if (isProd) {
  switch (WHITELABEL) {
    case 'hansjet':
      WL_ORG_ID = window.env.HANSJET_ORG_ID;
      WL_CLIENT_ID = window.env.HANSJET_CLIENT_ID;
      break;
    case 'mira':
      WL_ORG_ID = window.env.MIRA_ORG_ID;
      WL_CLIENT_ID = window.env.MIRA_CLIENT_ID;
      break;
    case 'airmobility':
    case 'friends':
      WL_ORG_ID = window.env.MYSKY_ORG_ID;
      WL_CLIENT_ID = window.env.FRIENDS_CLIENT_ID;
      break;
  }
} else {
  const href = window.location.href;
  const state = getParsedQuery(href.split('?')?.[1])?.state;
  const parsedStateQuery = getParsedQuery(`?${decodeURIComponent(state).split('?')?.[1]}`);

  const parsedQuery = getParsedQuery() as { _wl_: typeof process.env.WHITELABEL };
  const _wl_ = isFederationMode ? WHITELABEL : parsedStateQuery?._wl_ || parsedQuery._wl_ || WHITELABEL;

  switch (_wl_) {
    case 'mira':
      WL_ORG_ID = window.env.MIRA_ORG_ID;
      WL_CLIENT_ID = window.env.MIRA_CLIENT_ID;
      break;
    case 'hansjet':
      WL_ORG_ID = window.env.HANSJET_ORG_ID;
      WL_CLIENT_ID = window.env.HANSJET_CLIENT_ID;
      break;
    case 'airmobility':
    case 'friends':
      WL_ORG_ID = window.env.MYSKY_ORG_ID;
      WL_CLIENT_ID = window.env.FRIENDS_CLIENT_ID;
      break;
  }
}

if (isProd) {
  WHITELABEL_NAME = process.env.WHITELABEL;
} else {
  const { _wl_ } = getParsedQuery() as { _wl_: typeof process.env.WHITELABEL };
  WHITELABEL_NAME = isFederationMode ? WHITELABEL : _wl_ || WHITELABEL;
}
